import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import KeySelector from '@App/components/KeySelector/KeySelector';
import store from '@App/app.store';

import './key-control.css';

class KeyControl {
  constructor(map) {
    this._container = null;
    this._root = null;
    this.map = map;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-key-control`;

    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <KeySelector />
      </StoreProvider>,
    );

    return this._container;
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount();
      });
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }
  }
}

export default KeyControl;
